// extracted by mini-css-extract-plugin
export var container = "_4i-0";
export var disabled = "_4i-4";
export var fullWidth = "_4i-3";
export var lined = "_4i-1";
export var selected = "_4i-5";
export var tab = "_4i-2";